<header class="header">
  <div class="header-left">
    <!-- Toggle Button -->
    <button class="toggle-btn" (click)="onToggle()">
      @if (isSidebarOpen) {
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      }
    </button>

    <!-- Logo (Visible in header mostly on mobile, but Figma shows it in the header as well) -->
    <div class="header-logo">
      <img src="assets/images/logo-ribera.svg" alt="Logo" class="h-logo" />
    </div>

    <!-- Role Pill -->
    <div class="pill role-pill">
      Gestor de Restaurante
    </div>
  </div>

  <div class="header-right">
    <!-- Date Pill -->
    <div class="pill">
      <svg class="pill-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>
      {{ currentTime() | date:'EEE, dd MMM yyyy' }}
    </div>

    <!-- Time Pill -->
    <div class="pill">
      <svg class="pill-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
      {{ currentTime() | date:'hh:mm a' }}
    </div>

    <!-- User Profile Pill -->
    <div class="pill user-pill">
      <div class="avatar-circle">
        <img [src]="userAuth()?.avatar" alt="User" />
      </div>
      <div class="user-info">
        <span class="user-name">{{ userAuth()?.firstName }} {{ userAuth()?.lastName }}</span>
        <span class="user-role">ADMIN</span>
      </div>
      <svg class="chevron-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>

    <!-- Notifications -->
    <button class="pill icon-pill btn-bell">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
      </svg>
    </button>
  </div>
</header>
